/**
 * Drag and drop of files, on computers only (Matt, 2026-10-23 11:00): a fine pointer (a mouse or trackpad) and the
 * browser's drag events. Phones and tablets (a coarse pointer) show no drag text and no drop targets. Static: the start
 * screen uses it.
 */
export function canDragDrop(): boolean {
  try {
    return window.matchMedia('(pointer: fine)').matches && 'ondragstart' in document.documentElement && typeof DataTransfer !== 'undefined';
  } catch {
    return false;
  }
}

/** A drag that carries files (not text or a link dragged within the page). */
export function dragHasFiles(e: DragEvent): boolean {
  return Array.from(e.dataTransfer?.types ?? []).includes('Files');
}
